// extracted by mini-css-extract-plugin
module.exports = {"block":"_3727","hd":"_12910","icon":"_6454","title":"_13510","grow":"_563","arrow":"_10730","bd":"_18139"};